import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=994c7db2&scoped=true&"
import script from "./Styles.vue?vue&type=script&lang=js&"
export * from "./Styles.vue?vue&type=script&lang=js&"
import style0 from "./Styles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Styles.vue?vue&type=style&index=1&id=994c7db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994c7db2",
  null
  
)

export default component.exports